import React from 'react';
import { Smartphone } from 'lucide-react';

const InstallHelp = () => (
  <div className="bg-white rounded-xl p-4 border border-stone-200 shadow-sm">
    <h3 className="font-bold text-stone-800 flex items-center gap-2 mb-2">
      <Smartphone className="w-4 h-4 text-brand-500" /> התקנה על מסך הבית
    </h3>
    <p className="text-xs text-stone-500 mb-3">
      אם ניסית "הוסף למסך הבית" מהתפריט הרגיל של כרום וקיבלת קיצור-דרך קטן
      שנפתח כמו אתר (עם שורת הכתובת למעלה) במקום כמו אפליקציה - זה סימן
      שכרום עדיין לא זיהה את זה כאפליקציה שאפשר "להתקין" באמת. הדרך הבטוחה:
    </p>
    <ol className="text-xs text-stone-600 space-y-1.5 list-decimal pr-4">
      <li>סגור את הטאב ופתח את הכתובת שוב (טעינה שנייה נדרשת כדי שהאפליקציה תזוהה כניתנת להתקנה).</li>
      <li>חכה לרצועה הכחולה-זהובה שמופיעה למעלה עם כפתור "התקן" - זה המסלול הנכון.</li>
      <li>
        אם היא לא מופיעה: תפריט 3 הנקודות ⋮ בכרום → חפש שורה שכתוב בה
        <span className="font-semibold"> "התקן אפליקציה"</span> (לא "הוסף למסך הבית") ולחץ עליה.
      </li>
    </ol>
    <p className="text-xs text-stone-400 mt-3">באייפון: כפתור השיתוף 📤 ← "הוסף למסך הבית".</p>
  </div>
);

export default InstallHelp;
